import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { IntlProvider, addLocaleData} from 'react-intl'
import it from 'react-intl/locale-data/it'
import '../styles/Application.sass'
import './index.css'
import { AlertProvider } from '../components/Alert'

import itMessages from '../locales/it.js'
import enMessages from '../locales/en.js'

addLocaleData(it);

const messages = {
  it: itMessages,
  en: enMessages,
};

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isScrollActive: false,
    }
  }

  getChildContext() {
    return {toggleOverflow: (active) => this.toggleOverflow(active) }
  }

  toggleOverflow(active) {
    this.setState({isScrollActive: active})
  }

  render() {
    const locale = this.props.location.pathname.startsWith('/it') ? 'it' : 'en'

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <AlertProvider>
          <div className={this.state.isScrollActive ? `intro__overflow` : ``}>
            <Helmet
              title="Kubikoff"
              meta={[
                { name: 'description', content: 'Sample' },
                { name: 'keywords', content: 'sample, something' },
                { name: 'google-site-verification', content: 'ckfyPbLUkts8Iw5MPg-uX02O5pa7dN1rXdlVF1uosgY' },
              ]}
            />
            <script
              dangerouslySetInnerHTML={{
                __html: `
                (function (w,d) {
                  var loader = function () {
                    var s = d.createElement("script"),
                    tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js";
                    tag.parentNode.insertBefore(s,tag);
                  };
                  if(w.addEventListener){
                    w.addEventListener("load", loader, false);
                  }else if(w.attachEvent){
                    w.attachEvent("onload", loader);
                  }else{w.onload = loader;}
                })(window, document)
                `
              }}
            />
            <div>{this.props.children()}</div>
          </div>
        </AlertProvider>
      </IntlProvider>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

TemplateWrapper.childContextTypes = {
  toggleOverflow: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js